import { createResourceStore } from '@next-qr/lib-ui/store';
import { orgApi } from './api';

export const useOrgStore = createResourceStore(orgApi);
